class DropdownInput extends HTMLElement {
    static get observedAttributes() {
        return ['current-value']
    }

    connectedCallback() {
        this.initClickListener()
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'current-value') {
            if (newValue && newValue !== oldValue) {
                this.activeValueEl?.classList.remove('active')
                this.activeValueEl = this.querySelector(`.js-dropdown-value[data-value="${newValue}"]`)
                this.display.textContent = newValue 
                this.input && (this.input.value = newValue)
                this.activeValueEl?.classList.add('active')
                if (this.display.classList.contains('placeholder')) {
                    this.display.classList.remove('placeholder')
                }

                this.additionalCallback && this.additionalCallback(newValue, this)
            }
        }
    }

    constructor() {
        super(); 
        this.trigger = this.querySelector('.js-dropdown-trigger')
        this.display = this.trigger?.querySelector('.dropdown-value-display') 
        this.input = this.querySelector('input[type="hidden"]')
    }

    initClickListener() { 
        if (!window.dropdownListener) (window.dropdownListener = window.addEventListener('click', this.handleClick))
    }

    get currentValue() {
        return this.getAttribute('current-value') || null
    } 
    set currentValue(value) {
        if (value === null || value === undefined) {
            this.removeAttribute('current-value')
            if (this.display) this.display.textContent = ''
        } else {
            this.setAttribute('current-value', value)
            if (this.display) this.display.textContent = value
        }
    } 

    handleClick(evt) {  
        if (evt.target.classList.contains('js-dropdown-trigger')) {  
            evt.preventDefault();
            window.activeDropdown !== evt.target.closest('dropdown-input') && window.activeDropdown?.removeAttribute('open')
            evt.target.closest('dropdown-input').toggleAttribute('open')
            window.activeDropdown = evt.target.closest('dropdown-input') 
        } else if (evt.target.classList.contains('js-dropdown-value')) {
            evt.preventDefault(); 
            if (evt.target.closest('dropdown-input').currentValue != evt.target.dataset.value) { 
                evt.target.closest('dropdown-input').currentValue = evt.target.dataset.value 
            }
            evt.target.closest('dropdown-input').removeAttribute('open')
            window.activeDropdown = null

        } else { 
            window.activeDropdown?.removeAttribute('open')
            window.activeDropdown = null
        }
    }
}

!customElements.get('dropdown-input') && customElements.define('dropdown-input', DropdownInput)


class DatePicker extends HTMLElement {
    static get observedAttributes() {
        return ['age', 'month', 'year']
    }

    attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
            case 'month':
                if (newValue) { 
                    this.populateEntity(this.daysDropdown, 1, this.DaysMap[newValue])
                } 
            case 'year':
                if (newValue) {
                    this.DaysMap[2] = this.isLeapYear(newValue) ? 29 : 28
                    this.populateEntity(this.daysDropdown, 1, this.DaysMap[this.getAttribute('month')])
                }
        }

        if (name !== 'age') {
            this.parseValue()
        } else { 
            this.input.value = newValue
        }   
    }

     DaysMap = {
        1: 31, 
        2: 28, 
        3: 31,  
        4: 30,  
        5: 31, 
        6: 30,  
        7: 31, 
        8: 31,  
        9: 30,  
        10: 31,  
        11: 30, 
        12: 31 
    };
    
    constructor() {
        super();
        this.defaultDays = 31 
        this.optionTemplate = this.querySelector('.date-picker-option-template').content 
    }

    connectedCallback() {
        this.dropdowns = this.querySelectorAll('dropdown-input')
        this.daysDropdown = this.querySelector(`dropdown-input[data-entity="day"]`) 
        this.monthDropdown = this.querySelector(`dropdown-input[data-entity="month"]`)
        this.yearDropdown = this.querySelector(`dropdown-input[data-entity="year"]`)

        this.dropdowns.forEach(dropdown => this.populateEntity(dropdown))
        this.input = this.querySelector('input[type="hidden"]')
    }

    populateEntity(entity_dropdown, min, max) { 
        if (!entity_dropdown) return
        if (!entity_dropdown.additionalCallback) {
            entity_dropdown.additionalCallback = (value, instance) => {
                this.setAttribute(instance.dataset.entity, value) 
            }
        }
        entity_dropdown.querySelector('.js-dropdown-list-wrapper ul').innerHTML = ''
        const fragment = document.createDocumentFragment()
        min = min ?? entity_dropdown.dataset.min 
        max = max ?? entity_dropdown.dataset.max 

        if (entity_dropdown.hasAttribute('reverse-options')) {
            for (let i = max; i >= min; i--) {
                fragment.appendChild(this.renderOption(i))
            }
        } else {
            for (let i = min; i <= max; i++) {
                fragment.appendChild(this.renderOption(i))
            }
        }

        entity_dropdown.querySelector('.js-dropdown-list-wrapper ul').appendChild(fragment)
        if (entity_dropdown.currentValue > max) entity_dropdown.currentValue = max
    } 

    renderOption(value) {
        const option = this.optionTemplate.cloneNode(true)
        const btn = option.querySelector('.js-dropdown-value')
        btn.setAttribute('data-value', value)
        btn.textContent = value 
        btn.ariaLabel = value 

        return option
    }

    isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
    }

    getAge(date_of_birth) {
        const today = new Date();
        let age = today.getFullYear() - date_of_birth.getFullYear();

        const hasNotHadBirthdayThisYear =
        today.getMonth() < date_of_birth.getMonth() ||
        (today.getMonth() === date_of_birth.getMonth() &&
            today.getDate() < date_of_birth.getDate());

        if (hasNotHadBirthdayThisYear) {
            age--;
        }

        return age;
    }

    parseValue() {
        if (!this.getAttribute('day') || !this.getAttribute('month') || !this.getAttribute('year')) {
            this.removeAttribute('age')
        } else { 
            const dateOfBirth = new Date(this.getAttribute('year'), this.getAttribute('month') - 1, this.getAttribute('day')) 
            const age = this.getAge(dateOfBirth) 
            this.setAttribute('age', age) 
        } 
    }
}

customElements.whenDefined('dropdown-input').then(() => {
  if (!customElements.get('date-picker')) customElements.define('date-picker', DatePicker);
});
